export const ACCOUNT_ACTIONS = {
  PROFILE: 'profile',
  ORDERS: 'orders',
  REVIEWS: 'reviews',
  ADDRESSES: 'addresses',
  INVITATIONS: 'invitations',
  PAYMENT_METHODS: 'payment-methods',
  DETAILS: 'details',
  NEWSLETTERS: 'newsletters',
  MILES_AND_MORE: 'miles-and-more'
} as const

export type AccountAction =
  (typeof ACCOUNT_ACTIONS)[keyof typeof ACCOUNT_ACTIONS]

export interface AccountNavItem {
  action: AccountAction
  labelKey: string
  descriptionKey: string
}

export const ACCOUNT_NAV_ITEMS: readonly AccountNavItem[] = [
  {
    action: ACCOUNT_ACTIONS.PROFILE,
    labelKey: 'account_nav_profile',
    descriptionKey: 'account_nav_profile_desc'
  },
  {
    action: ACCOUNT_ACTIONS.ORDERS,
    labelKey: 'account_nav_orders',
    descriptionKey: 'account_nav_orders_desc'
  },
  {
    action: ACCOUNT_ACTIONS.REVIEWS,
    labelKey: 'account_nav_reviews',
    descriptionKey: 'account_nav_reviews_desc'
  },
  {
    action: ACCOUNT_ACTIONS.ADDRESSES,
    labelKey: 'account_nav_addresses',
    descriptionKey: 'account_nav_addresses_desc'
  },
  {
    action: ACCOUNT_ACTIONS.INVITATIONS,
    labelKey: 'account_nav_invitations',
    descriptionKey: 'account_nav_invitations_desc'
  },
  {
    action: ACCOUNT_ACTIONS.PAYMENT_METHODS,
    labelKey: 'account_nav_payment_methods',
    descriptionKey: 'account_nav_payment_methods_desc'
  },
  {
    action: ACCOUNT_ACTIONS.DETAILS,
    labelKey: 'account_nav_details',
    descriptionKey: 'account_nav_details_desc'
  },
  {
    action: ACCOUNT_ACTIONS.NEWSLETTERS,
    labelKey: 'account_nav_newsletter',
    descriptionKey: 'account_nav_newsletter_desc'
  },
  {
    action: ACCOUNT_ACTIONS.MILES_AND_MORE,
    labelKey: 'account_nav_miles_and_more',
    descriptionKey: 'account_nav_miles_and_more_desc'
  }
]

export type AccountActionComponentKey = 'placeholder' | 'details' | 'profile'

/**
 * Map of account action -> component key.
 * Used for dynamic content; actual components are resolved in TheAccountTemplate.
 * Replace placeholder keys with specific component keys when implementing sections.
 */
export const ACCOUNT_ACTION_COMPONENT_KEYS: Record<
  AccountAction,
  AccountActionComponentKey
> = {
  [ACCOUNT_ACTIONS.PROFILE]: 'profile',
  [ACCOUNT_ACTIONS.ORDERS]: 'placeholder',
  [ACCOUNT_ACTIONS.REVIEWS]: 'placeholder',
  [ACCOUNT_ACTIONS.ADDRESSES]: 'placeholder',
  [ACCOUNT_ACTIONS.INVITATIONS]: 'placeholder',
  [ACCOUNT_ACTIONS.PAYMENT_METHODS]: 'placeholder',
  [ACCOUNT_ACTIONS.DETAILS]: 'details',
  [ACCOUNT_ACTIONS.NEWSLETTERS]: 'placeholder',
  [ACCOUNT_ACTIONS.MILES_AND_MORE]: 'placeholder'
}
